// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"settings_wrapper__2fzg0","content":"settings_content__1rkdQ","addSection":"settings_addSection__hHjS2"};